<template dir="rtl">
  <b-form-input
    type="text"
    :class="`license-creation-input ${right ? 'right' : ''} ${disabled ? 'disabled-input' : ''}`"
    id="datepicker-input"
    :disabled="disabled"
  />
</template>

<script>
  import Flatpickr from 'flatpickr'
  import 'flatpickr/dist/flatpickr.css'

  export default {
    data () {
      return {
        datepicker: null,
        fromDate: null,
        toDate: null
      }
    },
    props: {
      right: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      value: {
        type: Array,
        default: null
      },
      format: {
        type: String,
        default: 'm/d/Y'
      }
    },
    mounted () {
      const formats = {
        'YYYY/MM/DD': 'Y/m/d',
        'DD/MM/YYYY': 'd/m/Y',
        'MM/DD/YYYY': 'm/d/Y'
      }
      this.datepicker = new Flatpickr(this.$el, {
        mode: 'range',
        dateFormat: formats[this.format || 'MM/DD/YYYY'],
        static: true,
        defaultDate: this.value,
        onChange: ([f, t]) => {
          if (f) {
            const date = new Date(f.getFullYear(), f.getMonth(), f.getDate())
            this.fromDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
              .toISOString()
          }
          if (t) {
            const date = new Date(t.getFullYear(), t.getMonth(), t.getDate())
            this.toDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
              .toISOString()
          }
          this.$emit('dateChange', { fromDate: this.fromDate, toDate: this.toDate })
        }
      })
    }
  }
</script>

<style scoped lang="scss">
  @import '../styles/variables.scss';
  .form-control:disabled {
    background-color: white !important;
    border: none !important;
    cursor: not-allowed;
  }
  input#datepicker-input.flatpickr-input {
    border: none !important;
  }
  input.form-control:focus {
    border: none;
    outline: none;
    box-shadow: none;
  }
  input.disabled-input {
    color: $darkGray;
  }
</style>



// WEBPACK FOOTER //
// src/components/Datepicker.vue